import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BpgCommonService } from '../services/bpg-common.service';

import { ConstantValues } from '../models/bpg-constants';

@Component({
  selector: 'app-header',
  templateUrl: './bpg-header.component.html',
  styleUrls: ['./bpg-header.component.css']
})
export class BpgHeaderComponent implements OnInit {
  navbarOpen = false;
  login_data: string;
  userFirstName: string;
  userLastName: string;
  siteName: string;
  userSiteId: any;
  getUserSiteDetails: any;
  headerRefresh: boolean;
  loginError: boolean;
  loginData: any;
  userData: string;
  userIdDto: any;
  userRoleDetails: any;

  constructor(
    private router: Router,
    private bpgCommonService: BpgCommonService,
    ////BY KRISHNA - commented
  ) {
    // this.bpgCommonService.headerRefresh.subscribe(value =>{
    //   this.headerRefresh = value;
    //   if(this.headerRefresh == true){
    //    this.ngOnInit();
    //  }
    // })

    this.bpgCommonService.loginError.subscribe(value => {
      this.loginError = value;
      if (this.loginError == false) {
        this.loginError = false;

      }
    })
    {

      this.bpgCommonService.setloggedInObservable().subscribe(val => {



        if (val) {
         
          this.pageOnLoadFunction()
          // this.getAwsUrls();
        }



      });




    }
  }

  ngOnInit() {


    //  this.adalLoginUserDetails()
    // console.log(localStorage.getItem('loginData'))
    // if (localStorage.getItem('loginData')==null || localStorage.getItem('loginData')==undefined) {
    //   setTimeout(function () {
    //     if (localStorage.getItem('loginData')) {

    //       this.pageOnLoadFunction()
    //       this.getAwsUrls();
    //     }


    //   }.bind(this), 2000);
    // }
    // if (localStorage.getItem('loginData')) {

    //   this.pageOnLoadFunction()
    //   this.getAwsUrls();
    // }

  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  logOut() {
    localStorage.clear();
    sessionStorage.clear();
    
    this.router.navigate(['/log-out']);
    //this.getAwsUrls();


    // if (ConstantValues.env.loginADAL == true) {
    //   //this.router.navigate['/log-out'];//BY KRISHNA - commented
    // } else {
    //   this.router.navigate(['/login']);
    // }

  }

  public getAwsUrls() {
    const awsDetails = {
      "awsUrl": "",
      "category": "SITE_BANNER"
    }
    this.bpgCommonService.getAwsUrl(awsDetails).subscribe(data => {

      localStorage.setItem("siteBannerBaseUrl", data.awsUrl);

      const awsDetails = {
        "awsUrl": "",
        "category": "CHAPTER_BANNER"
      }
      this.bpgCommonService.getAwsUrl(awsDetails).subscribe(data => {
        localStorage.setItem("chapterBannerBaseUrl", data.awsUrl);

        const awsDetails = {
          "awsUrl": "",
          "category": "CHAPTER_LEADERSHIP"
        }
        this.bpgCommonService.getAwsUrl(awsDetails).subscribe(data => {
          localStorage.setItem("chapterLeadershipBannerBaseUrl", data.awsUrl);
        })
      })
    })


  }

  /** For getting user details on adal
   * @method adalLoginUserDetails
   */
  adalLoginUserDetails() {
    localStorage.setItem("logOutFlag", "false");
    console.log("logout flag " + localStorage.getItem("logOutFlag"))
    if (!sessionStorage.getItem('userEmail')) {
      {
        this.bpgCommonService.userLogin();
      }
      if (sessionStorage.getItem('userEmail')) {

        let emailDto = {
          "userEmailId": sessionStorage.getItem('userEmail')

        }

        this.bpgCommonService.userDetailsByEmailId(emailDto).subscribe(data => {
          this.loginData = data;
          console.log("###Header component###")
          console.log(JSON.stringify(this.loginData));
          if (data.emailId == null) {
            this.bpgCommonService.loginError.next(false);
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(['/login-error']);
          } else {
            localStorage.setItem('loginData', JSON.stringify(this.loginData));
            this.userData = JSON.parse(localStorage.getItem('loginData'));
            this.userIdDto = { "userId": this.userData['userId'] };

            this.bpgCommonService.getUserRoleDetails(this.userIdDto).subscribe(data => {

              this.userRoleDetails = data;
              localStorage.setItem('userSiteId', this.loginData['site']['siteId']);
              localStorage.setItem('adminId', this.userRoleDetails['adminId']);
              localStorage.setItem('selectedSiteId', this.loginData['site']['siteId']);
              localStorage.setItem('leadAdminId', this.userRoleDetails['leadAdminId']);

              window.location.reload();
              this.pageOnLoadFunction();
            })
          }

        })
      }
    }
  }

  pageOnLoadFunction() {

    this.login_data = JSON.parse(localStorage.getItem('loginData'));
    this.userSiteId = this.login_data['site']['siteId'];
   
    if (this.userSiteId != null) {
      this.bpgCommonService.getUserSiteDeatils(this.userSiteId).subscribe(data => {
        this.getUserSiteDetails = (data) ? data : '';
        this.siteName = this.getUserSiteDetails.siteName;
        if (this.login_data) {
         
          this.userFirstName = this.login_data['userFirstName'];
          this.userLastName = this.login_data['userLastName'];

        }
        else {
          this.userFirstName = "";
          this.userLastName = "";
        }
       
       
      });
    }

  }
}
